/**
 * Stripe Elements appearance variables shared by the payment forms. Its own module because it used to live in
 * StripeElementProvider, whose module-level Stripe.js load then ran on every page that imported a payment form.
 */
export const stripeStyle = {
  colorPrimary: '#0570de',
  colorBackground: '#30313d',
  colorText: 'white',
  colorDanger: '#df1b41',
  borderRadius: '4px',
  colorPrimaryText: 'white',
  fontSizeSm: '1rem',
};
